<template>
  <RygenMultiSelect
    :id="id"
    v-model="internalValue"
    :disabled="disabled"
    :loading="serviceLevels.loading"
    :options="serviceLevels.data"
    :placeholder="placeholder"
    class="service-multi-select"
    display="chip"
    option-label="name"
    filter
  />
</template>

<script lang="ts" setup>
import { usePrimeVue } from 'primevue/config';
import { computed, onMounted, PropType, toRefs, useAttrs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue, useUid } from '@rygen/rygen-ui/composables';
import { ServiceLevel } from '@rygen/rygen-ui/model';

import { useServiceLevelStore } from '@/stores/ServiceLevel';

import RygenMultiSelect from '@rygen/rygen-ui/components/form/RygenMultiSelect.vue';

const props = defineProps({
  id: {
    type: String,
    default: () => useUid('service-multi-select').uid,
  },
  modelValue: {
    type: Array as PropType<ServiceLevel[]>,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
});
const { id, modelValue, disabled } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: ServiceLevel[]): void;
}>();

const attrs = useAttrs();
const { t } = useI18n();
defineExpose({
  $primevue: usePrimeVue(),
});

const { serviceLevels, loadServiceLevels } = useServiceLevelStore();

const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<ServiceLevel[]>) => opts as ServiceLevel[],
});

const placeholder = computed(() => {
  return (attrs.placeholder as string) ?? t('shipments.services', 1);
});

onMounted(() => {
  loadServiceLevels();
});
</script>
